import React from "react";

import { CloudAssetDetailsPageHeader } from "../../../../../header/CloudAssetDetailsPageHeader";
import { EditCloudAssetContentForm } from "./EditCloudAssetContentForm";

export const EditCloudAssetContentDashboard = (): JSX.Element => {
    return (
        <>
            <CloudAssetDetailsPageHeader hideActions={true} />
            <EditCloudAssetContentForm />
        </>
    );
};
